import { WhInfoCargoesContent } from 'components/wh-info/wh-info-cargoes-content';
import styles from './wh-info-board.module.scss';

export const WhInfoBoard = () => {
  return (
    <div className={styles.whInfoContainer}>
      <WhInfoCargoesContent />
    </div>
  );
};
